import React, { useState, useCallback, useContext, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import metadata from './AdditionalInterestsStep.metadata.json5';
import TWIABuildingLocationAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion';
import TWIABuildingInfoAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingInfoAccordion/TWIABuildingInfoAccordion';
import TWIABuildingConstructionAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingConstructionAccordion/TWIABuildingConstructionAccordion';
import TWIABuildingCoveragesAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingCoveragesAccordion/TWIABuildingCoveragesAccordion';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import BuildingAdditionalInterestComponent from '../../BuildingAdditionalInterest/BuildingAdditionalInterestComponent/BuildingAdditionalInterestComponent';
import TWIAWizardMessagesMessages from '../../../../../modules-react/twia-portals-wizard-components-ui/common/TWIAWizardMessages.messages';

function AdditionalInterestsStep(props) {
    const { id, handleNextClick, handleCancelClick, handleEditLinkClick, submissionVM, updateWizardData, showStepper } = props;
    const { isComponentValid, onValidate, disregardFieldValidation } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [buildingVM, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]); 
    const [invalidComponent, setInvalidComponents] = useState([]);
    const locationId = _.get(buildingVM, 'locationId.value');
    const buildingId = _.get(buildingVM, 'publicID.value');
    const translator = useContext(TranslatorContext);
    

    const findInvalidComponent = useCallback((isValid, componentID) => {
        setShowErrors(false);

        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const cancelBuilding = useCallback(async () => {
        await handleCancelClick(selectedLocation, setSelectedLocation);
    }, [handleCancelClick, selectedLocation, setSelectedLocation]);

    const onNext = useCallback(() => {
        console.log(invalidComponent)
        if(!isComponentValid) {
            setShowErrors(true);
            return false
        }
        handleNextClick();
    }, [isComponentValid, handleNextClick])

    const overrideProps = {
        locationAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        buildingAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        constructionAccordion: {
            visible: showStepper,
            handleEditLinkClick
        },
        coveragesAccordion: {
            visible: showStepper,
            handleEditLinkClick,
            buildingVM,
            isAdditionalStep: true,
            fromBuilding: false
        },
        buildingAdditionalInterest: {
            submissionVM, updateWizardData, showErrors, 
            findInvalidComponent, onValidate, locationId, buildingId,disregardFieldValidation
        },
        nextButton: {
            content: !showStepper ? translator(TWIAWizardMessagesMessages.TWIAWizardModalSaveBuilding)
                : translator(TWIAWizardMessagesMessages.TWIAWizardModalNext)
        },
        wizardActionButtons: {
            justifyContent: !showStepper ? 'right' : 'between'
        },
    }

    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveCallbackMap: {
            onNext,
            handleCancelClick: cancelBuilding
        },
        resolveComponentMap: {
            TWIABuildingLocationAccordion,
            TWIABuildingInfoAccordion,
            TWIABuildingConstructionAccordion,
            TWIABuildingCoveragesAccordion,
            BuildingAdditionalInterestComponent
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />
    )
}

export default AdditionalInterestsStep